import { ICost } from "@eventr/common";
import { StandardExpenseFormValues, DistanceExpenseFormValues } from "./forms/expense-form-utils";

type BaseMappedFields = Pick<
  ICost,
  "amount" | "currency" | "name" | "invoice_date" | "category" | "cost_center" | "expense_type"
>;

type StandardExpenseMapper = BaseMappedFields & Pick<ICost, "merchant">;
type DistanceExpenseMapper = BaseMappedFields & Pick<ICost, "distance_info">;

type ExpenseMapper<T, R> = (data: T) => R;

export const mapStandardExpense: ExpenseMapper<StandardExpenseFormValues, StandardExpenseMapper> = (data) => ({
  amount: Number(data.amount),
  currency: data.currency,
  name: data.description,
  invoice_date: data.invoiceDate,
  category: Number(data.category),
  cost_center: data.costCenter,
  expense_type: "standard",
  merchant: data.merchant,
  receipt_file: data.fileData,
});

export const mapDistanceExpense: ExpenseMapper<DistanceExpenseFormValues, DistanceExpenseMapper> = (data) => ({
  amount: Number(data.rate) * Number(data.distance),
  currency: data.currency,
  name: data.description,
  invoice_date: data.invoiceDate,
  category: Number(data.category),
  cost_center: data.costCenter,
  expense_type: "distance",
  distance_info: {
    distance: Number(data.distance),
    rate: Number(data.rate),
    distance_unit: data.distanceUnit,
    number_of_passengers: Number(data.numberOfPassengers),
    start_location: data.startLocation,
    end_location: data.endLocation,
  },
});
